import { render, staticRenderFns } from "./Create-Addons.vue?vue&type=template&id=36b64a0a"
import script from "./Create-Addons.vue?vue&type=script&lang=js"
export * from "./Create-Addons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports